import {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {Debugger} from "debug";
import {erLikIgnorerCasing} from "felles/tjenester/Strenger";
import {RedigerEksterneDeltakereKontroller} from "./redigerEksterneDeltakere";

const debug: Debugger = require('debug')('redigerEksterneDeltakereSkjemalinjeKontroller');
const css = require('./redigerEksternDeltakerSkjemalinje.scss');

export class RedigerEksternDeltakerSkjemalinjeKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmEksternDeltakerSkjemalinje', {
                bindings: {deltaker: '<', visSlettknapp: '<'},
                controller: RedigerEksternDeltakerSkjemalinjeKontroller.forInjisering(),
                template: require('./redigerEksternDeltakerSkjemalinje.html'),
                require: {redigerDeltakereKontroller:'^wmRedigerEksterneDeltakere'}
            });
    }

    static forInjisering() {
        return [
            RedigerEksternDeltakerSkjemalinjeKontroller
        ];
    }

    deltaker: RedigerEksternMøtedeltakerModell; //settes via bindings/$onChanges
    visSlettknapp: boolean; //settes via bindings/$onChanges

    redigerDeltakereKontroller: RedigerEksterneDeltakereKontroller; //settes via require

    constructor() {
    }

    endring() {
       this.redigerDeltakereKontroller.sikreAtSisteRadErBlanktInnslag();
    }

    /** Forhindrer duplikate navn */
    validerNavn(navnVerdi:string){
        return !this.redigerDeltakereKontroller.deltakere.some(kandidat =>
            kandidat !== this.deltaker && !_.isEmpty(navnVerdi) && erLikIgnorerCasing(kandidat.spesifikasjon.navn, navnVerdi));
    }

    slett() {
        this.deltaker.slettet = true;

        //dersom all tekst er fjernet på en eksisterende deltaker - reset til opprinnelig verdi
        if (this.deltaker.spesifikasjon.id !== null && _.isEmpty(this.deltaker.spesifikasjon.navn))
            this.deltaker.spesifikasjon.navn = this.deltaker.modell.navn;

        //fjern fra listen dersom dette er et nytt innslag og navn er tomt
        if (this.deltaker.spesifikasjon.id === null && _.isEmpty(this.deltaker.spesifikasjon.navn))
            _.remove(this.redigerDeltakereKontroller.deltakere, kandidat => kandidat === this.deltaker);
    }

    angreSletting(){
        this.deltaker.slettet = false;
    }

    // hjelpemetoder
}

export class RedigerEksternMøtedeltakerModell {
    spesifikasjon: l.EksternMøtedeltakerSpesifikasjon;
    modell: l.EksternMøtedeltakerModell;
    slettet = false;

    static tomRedigerEksternDeltakerModell() {
        const modell = new RedigerEksternMøtedeltakerModell({id: null, navn: '', rolle: '', kommentar: '', gruppeId: null, moeteId: null});
        return modell;
    }

    constructor(modell: l.EksternMøtedeltakerModell) {
        this.modell = modell;
        this.spesifikasjon = {id: this.modell.id, navn: this.modell.navn, rolle: this.modell.rolle, kommentar: this.modell.kommentar};
    }
}
